var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.2442 0H5.94234C4.87231 0 4.00488 0.867428 4.00488 1.93745V12.7898C4.00488 13.8598 4.87231 14.7273 5.94234 14.7273H15.2442C16.3143 14.7273 17.1817 13.8598 17.1817 12.7898V1.93745C17.1817 0.867428 16.3143 0 15.2442 0Z",
  fill: "#D20071"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9093 15.5454V15.9545C13.9091 16.4969 13.6935 17.0171 13.3099 17.4006C12.9264 17.7842 12.4062 17.9998 11.8638 18H2.86381C2.32139 17.9998 1.80125 17.7842 1.4177 17.4006C1.03415 17.0171 0.818576 16.4969 0.818359 15.9545V5.31816C0.818576 4.77574 1.03415 4.25559 1.4177 3.87204C1.80125 3.48849 2.32139 3.27292 2.86381 3.27271H3.18302V12.7882C3.18475 13.5189 3.47578 14.2192 3.99247 14.7359C4.50916 15.2526 5.20945 15.5437 5.94018 15.5454H13.9093Z",
  fill: "#D20071"
})));
export default SvgCopy;